<!--
 * @Author: your name
 * @Date: 2021-12-14 15:42:26
 * @LastEditTime: 2021-12-14 16:08:31
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \GeelyEmail_Mobile\src\components\swipeBtn\index.vue
-->
<template>
	<div :class="`swiper-btn swiper-btn_${type}`" @click="handClick">
		<div class="swiper-content">
			<img :src="data[type].url" alt="" />
			<span>{{ data[type].txt }}</span>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			data: {
				delete: {
					url: require('../../assets/svg/swiper_delte.svg'),
					txt: '删 除'
				},
				'no-read': {
					url: require('../../assets/svg/swiper_star.svg'),
					txt: '标记未读'
				},
				star: {
					url: require('../../assets/svg/swiper_star.svg'),
					txt: '设为星标'
				}
			}
		}
	},
	props: {
		/* no-read star  delete*/
		type: {
			type: String,
			default: 'delete'
		}
	},
	methods: {
		handClick() {
			this.$emit('swiperBtnClick')
		}
	}
}
</script>

<style lang="less" scoped>
.swiper-btn {
	min-width: 72px;
	height: 90px;
	position: relative;
	display: inline-block;
	.swiper-content {
		position: absolute;
		width: 100%;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		img {
			width: 20px;
			height: 20px;
			margin-bottom: 5px;
		}
		span {
			color: #fff;
			font-size: 12px;
		}
	}
}
.swiper-btn_no-read {
	background: #b2b2b2;
}
.swiper-btn_star {
	background: #fad00e;
}
.swiper-btn_delete {
	background: #ef4f4f;
}
</style>
